import axios from "axios";
const instance = axios.create({
  baseURL: "https://sherry-devconnector.herokuapp.com/",
});
export default instance;
